import gql from 'graphql-tag';

export default gql`
  query GetBellyLoadAllocaions($loadId: Int) {
    getBellyLoadAllocaions(loadId: $loadId) {
      id
      index
      loadId
      jobId
      boxId
      proppantId
      boxDesc
      allocationWeight
      isBoxAllocated
      isLoadAllocated
      isInDanceFloor
      weightRemaining
    }
  }
`;